import {
  subDays,
  subMonths,
  subYears,
  startOfYear,
  endOfYesterday,
} from "date-fns";

export const isDateInSelectedRange = (date: Date, selectedRangeId: string) => {
  const today = endOfYesterday();

  switch (selectedRangeId) {
    case "DAYS-6":
      return isDateInRange(date, subDays(today, 6), today);
    case "MONTHS-1":
      return isDateInRange(date, subMonths(today, 1), today);
    case "MONTHS-3":
      return isDateInRange(date, subMonths(today, 3), today);
    case "CALYEAR-0":
      return isDateInRange(date, startOfYear(today), today);
    case "YEARS-1":
      return isDateInRange(date, subYears(today, 1), today);
    case "YEARS-3":
      return isDateInRange(date, subYears(today, 3), today);
    case "YEARS-5":
      return isDateInRange(date, subYears(today, 5), today);
    case "CALENDYEAR-0":
      // Assuming "All" means all dates up until today. You might need to adjust based on the oldest date you have.
      return isDateInRange(date, new Date(0), today);
    default:
      return true;
  }
};

export const toShortISOString = (date: Date) =>
  `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;

export const startOfMonth = (date: Date) => {
  const resultDate = new Date(date);
  resultDate.setDate(1);
  resultDate.setHours(0, 0, 0, 0);

  return resultDate;
};

export const dateFromYYYYMMDD = (stringDate: string) => {
  const dateArray = stringDate.split("-").map((period) => parseInt(period));
  return new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
};

export const dateToYYYYMMDD = (date: Date) => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // getMonth() is zero-based
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

export const isDateInRange = (
  date: Date,
  startDate: Date | undefined,
  endDate: Date | undefined
) => {
  const dateTime = date.getTime();
  const isOlder = !startDate || dateTime >= startDate.getTime();
  const isYounger = !endDate || dateTime <= endDate.getTime();

  return isOlder && isYounger;
};
